import React, { lazy } from 'react';
import ExternalPage from '../container/externalReviewProof/ExternalPage';
import ExternalReviewImage from '../container/externalReviewProof/ExternalReviewImage';

function ExternalNoteForm() {
  return (
    <>
      <ExternalPage>
        <ExternalReviewImage />
      </ExternalPage>
    </>
  );
}

export default ExternalNoteForm;
